<template>
  <v-jumbotron
    src="/static/login.jpg"
    height='1000px'
    dark
  >
  <v-container>
    <v-layout>
      <v-flex xs4 offset-xs4>
         <v-card class='mt-5'>
          <v-card-text>
            <v-container>
              <v-layout>
      <v-flex xs4 offset-xs3>
              <input type='image' height="40" @click='googleSignIn' src='/static/btn_google_signin.png'/>
            </v-flex>
          </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card class='mt-5'>
          <v-card-text>
            <v-container>
              <form @submit.prevent='onSignIn'>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name ='email'
                      label='Mail'
                      id='email'
                      v-model='email'
                      type='email'
                      required>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name='password'
                      label='Password'
                      id='password'
                      v-model='password'
                      type='password'
                      required>
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-btn type='submit'>Sign In</v-btn>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
<!--       <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <v-card-text>
            <v-container>
              <v-btn @click='googleSignin'>google Auth</v-btn>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex> -->
    </v-layout>
  </v-container>
    </v-jumbotron>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },
  computed: {
    ...mapGetters('user', {
      user: 'user'
    })
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/projectSelector')
      }
    }
  },
  methods: {
    ...mapActions('user', {
      logInUser: 'logInUser'
    }),
    onSignIn () {
      this.logInUser({email: this.email, password: this.password})
        // this.$store.dispatch('logInUser', {email: this.email, password: this.password})
    },
    googleSignIn () {
      console.log('googleauth')
        // this.$store.dispatch('googleSignUp')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/LogIn.vue